// api/login.ts
import axios, { isAxiosError } from 'axios'; // 기본 axios 모듈에서 isAxiosError 가져오기
import axiosInstance from '../plugin/axios';

interface LoginRequest {
  passid: string;
  password: string;
}

interface LoginResponse {
  token: {
    accessToken: string;
    refreshToken: string;
    expire: number;
  };
  userType: string;
}

export const loginHandler = async (
  data: LoginRequest,
): Promise<LoginResponse> => {
  try {
    const response = await axiosInstance.post<LoginResponse>(
      '/api/user/auth/signin',
      data,
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || '로그인 요청에 실패했습니다.',
      );
    } else {
      throw new Error('Unexpected error occurred during login');
    }
  }
};
